/**
 * Demo data for DSOK Daily Menu Admin. Built from daily-menu-screen dataset.
 * One menu, same offer for all 7 days (Mon–Sun). Used when localStorage is empty.
 */
const DEFAULT_MENU_ID = "5485bdffb2f120fdac12ddcfe4d20de4";

const INLINE_DEMO_PRODUCTS = {
  soups: [
    { id: "s1", number: 1, title: { "sk-SK": "Fazuľová polievka", "en-US": "Bean soup" }, price: "1.20", isActive: true, allergens: [1, 3] },
    { id: "s2", number: 2, title: { "sk-SK": "Kurací vývar", "en-US": "Chicken soup" }, price: "1.50", isActive: false, allergens: [1, 7] },
  ],
  meals: [
    { id: "m1", number: 1, title: { "sk-SK": "Sviečková na smotane", "en-US": "Beef sirloin" }, price: "6.90", isActive: true, allergens: [1, 3, 7] },
    { id: "m2", number: 2, title: { "sk-SK": "Rezeň s hranolčekmi", "en-US": "Schnitzel with fries" }, price: "5.50", isActive: true, allergens: [1, 3, 8] },
    { id: "m3", number: 3, title: { "sk-SK": "Guláš s chlebom", "en-US": "Goulash with bread" }, price: "5.20", isActive: false, allergens: [1, 4] },
  ],
  title: { "sk-SK": "Denné menu", "en-US": "Daily menu" },
  ticker: {
    text: {
      "sk-SK": "Vitajte v našej reštaurácii. Prajeme vám dobrú chuť!",
      "en-US": "Welcome to our restaurant. Enjoy your meal!",
    },
  },
};

function buildProductsById() {
  const byId = {};
  const soups = Array.isArray(INLINE_DEMO_PRODUCTS.soups) ? INLINE_DEMO_PRODUCTS.soups : [];
  const meals = Array.isArray(INLINE_DEMO_PRODUCTS.meals) ? INLINE_DEMO_PRODUCTS.meals : [];
  soups.forEach((p) => {
    if (p && p.id) byId[p.id] = { ...p };
  });
  meals.forEach((p) => {
    if (p && p.id) byId[p.id] = { ...p };
  });
  return byId;
}

function buildDefaultDay(productsById, soupIds, mealIds) {
  const ticker = INLINE_DEMO_PRODUCTS.ticker ? { text: INLINE_DEMO_PRODUCTS.ticker.text } : {};
  return {
    soups: soupIds.slice(),
    meals: mealIds.slice(),
    ticker,
    updatedAt: new Date().toISOString(),
  };
}

function getDefaultMenus() {
  const productsById = buildProductsById();
  const soupIds = Object.keys(productsById).filter((id) => id.startsWith("s"));
  const mealIds = Object.keys(productsById).filter((id) => id.startsWith("m"));
  const days = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ];
  const daysObj = {};
  days.forEach((day) => {
    daysObj[day] = buildDefaultDay(productsById, soupIds, mealIds);
  });
  const menu = {
    id: DEFAULT_MENU_ID,
    name: INLINE_DEMO_PRODUCTS.title ? { ...INLINE_DEMO_PRODUCTS.title } : { "sk-SK": "Denné menu", "en-US": "Daily menu" },
    days: daysObj,
    productsById,
  };
  return { menus: [menu] };
}

export const defaultAdminData = getDefaultMenus();
export const defaultMenuId = DEFAULT_MENU_ID;
export default defaultAdminData;
